import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";
import { RestaurantSegmentEnum } from "@enums";
import { iPermissionFields, PermissionSection } from "@models/PermissionSection";

const SEGMENT_NAME_TO_ENUM: Record<string, RestaurantSegmentEnum> = {
    'All': RestaurantSegmentEnum.ALL,
    'Casual Dining': RestaurantSegmentEnum.CASUAL_DINING,
    'Fast Casual': RestaurantSegmentEnum.FAST_CASUAL,
    'Fine Dining': RestaurantSegmentEnum.FINE_DINING,
    'Midscale': RestaurantSegmentEnum.MIDSCALE_DINING,
    'QSR': RestaurantSegmentEnum.QUICK_SERVICE,
};

type Response = components["schemas"]["TopPlacesDetailsIListChainPermissionWrapper"];
export type TopPlacesDetails = components["schemas"]["TopPlacesDetails"];
export type TopPlacesData = iPermissionFields & {
    data: Map<RestaurantSegmentEnum, TopPlacesDetails>;
};

const REQUEST_TYPE: keyof typeof apiConfig = 'get home top chains by nps';

const DEFAULT_DATA: TopPlacesData = {
    permissionLevel: PermissionSection.getPermissionLevel(),
    hasData: true,
    data: new Map<RestaurantSegmentEnum, TopPlacesDetails>(),
}

const transformData = (response?: Response): TopPlacesData => {
    const { permissionLevel, hasData = true, data = [] } = response || {};
    const dataMap = new Map<RestaurantSegmentEnum, TopPlacesDetails>();
    
    for (const item of data ?? []) {
        const segmentId = item.name ? SEGMENT_NAME_TO_ENUM[item.name] : null;
        
        if (segmentId) dataMap.set(segmentId, item);
    }
    
    return {
        permissionLevel: PermissionSection.getPermissionLevel(permissionLevel),
        hasData,
        data: dataMap,
    };
};

async function getTopChainsByNPS(): Promise<TopPlacesData> {
    try {
        const response: Response = await http.get(REQUEST_TYPE);
        
        return transformData(response);
    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return DEFAULT_DATA;
    }
}

export function useHomeTopChainsByNPS() {
    return useData(DEFAULT_DATA, getTopChainsByNPS);
}